// Generated code for Big.Entities.DiplomaWaardering.
// Edit _Enum.tst to change the generated output.

export enum DiplomaWaardering {
    onbekend = 0,
    voortgezetOnderwijsWaardering = 1,
    mboWaardering = 2,
    hboWaardering = 3,
    woWaardering = 4,
    mbo4Niveau = 5,
    hboBachelorNiveau = 6,
    woMasterNiveau = 7,
    postMasterNiveau = 8,
    overigNiveau = 9,
    postHboNiveau = 10,
    hboMasterWaardering = 11,
    hboMasterNiveau = 12,
    mbo3Niveau = 13,
    woBachelorNiveau = 14,
    mboNiveau3 = 15,
    woBachelor = 16
}
(DiplomaWaardering as any).name = 'DiplomaWaardering';
